type OptionsObjectTypes = {
  [key: string]: string;
};

type UserOptionObjectTypes = {
  [key: string]: string | boolean;
  phone_number?: string;
};

export const userOptions: UserOptionObjectTypes = {
  username: "",
  email: "",
  address: "",
  first_name: "",
  last_name: "",
  phone_number: "",
  password: "",
};

export const userOptionKeys: OptionsObjectTypes = {
  username: "username",
  email: "email",
  address: "address",
  firstName: "first_name",
  lastName: "last_name",
  phoneNumber: "phone_number",
  password: "password",
};
